"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var NumberComp = function NumberComp(_ref) {
  var amount = _ref.amount,
      total = _ref.total;
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1",
    color: "textSecondary"
  }, "(", amount, "/", total, ")");
};

NumberComp.propTypes = {
  total: _propTypes["default"].number.isRequired,
  amount: _propTypes["default"].number.isRequired
};
var _default = NumberComp;
exports["default"] = _default;